import _ from 'lodash'
import moment from 'moment'

export const DAYS_OPTIONS = _.map(moment.weekdays(), (day) => ({ label: day, value: day.toLocaleLowerCase() }))
